module.exports = __webpack_public_path__ + "img/menu-settings-button.c501cedf.svg";